import { createSelector } from "reselect"
import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("servicepackageservice")

export const servicePackageServiceReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_SERVICEPACKAGESERVICE":
			return [...state, action.response[0]]

		case "UPDATE_SERVICEPACKAGESERVICE":
			return state.map((object, i) => {
				let newObject = JSON.parse(JSON.stringify(object))
				if (newObject.servicepackageserviceid === action.id) {
					for (const data in action.json) {
						newObject[data] = action.json[data]
					}
					return newObject
				} else {
					return newObject
				}
			})

		case "DELETE_SERVICEPACKAGESERVICE":
			return state.filter((object) => object.servicepackageserviceid !== action.spsid)

		default:
			return state
	}
}

export const selectServicesByPhaseId = createSelector(
	(state, phaseId) => state.servicePackageServiceReducer,
	(_, phaseId) => phaseId,
	(services, phaseId) => {
		return services.filter((service) => phaseId === service.phaseid)
	}
)

export const selectServicesByPhaseIdAndPackageId = createSelector(
	(state, phaseId, packageId) => state.servicePackageServiceReducer,
	(_, phaseId) => phaseId,
	(_, __, packageId) => packageId,
	(services, phaseId, packageId) => {
		return services.filter((service) => phaseId === service.phaseid && packageId === service.servicepackageid)
	}
)
